(function () {
  if (window.ScrollReveal) return;

  const DEFAULTS = {
    selector: '.reveal',
    activeClass: 'is-visible',
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1,
    once: true,
    staggerMs: 0,
    container: document,
  };

  class ScrollRevealCore {
    constructor(options = {}) {
      this.options = { ...DEFAULTS, ...options };
      this.elements = [];
      this.observer = null;
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._init();
    }
    _init() {
      this.elements = Array.from(this.options.container.querySelectorAll(this.options.selector));
      if (!this.elements.length) return;
      if (this._reducedMotion || typeof IntersectionObserver === 'undefined') {
        this.elements.forEach((el) => el.classList.add(this.options.activeClass));
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => this._onIntersect(entries),
        { root: this.options.root, rootMargin: this.options.rootMargin, threshold: this.options.threshold }
      );
      this.elements.forEach((el) => this.observer.observe(el));
    }
    _onIntersect(entries) {
      entries.forEach((entry) => {
        const el = entry.target;
        if (entry.isIntersecting) {
          this._reveal(el);
          if (this.options.once) this.observer.unobserve(el);
        } else if (!this.options.once) {
          el.classList.remove(this.options.activeClass);
        }
      });
    }
    _reveal(el) {
      const delay = this._resolveDelay(el);
      if (delay) el.style.transitionDelay = `${delay}ms`;
      el.classList.add(this.options.activeClass);
      el.addEventListener('transitionend', () => { el.style.willChange = 'auto'; }, { once: true });
    }
    _resolveDelay(el) {
      if (el.dataset.revealDelay !== undefined) return parseInt(el.dataset.revealDelay, 10) || 0;
      if (!this.options.staggerMs) return 0;
      const group = el.closest('[data-reveal-group]');
      const siblings = group ? Array.from(group.querySelectorAll(this.options.selector)) : this.elements;
      return Math.max(0, siblings.indexOf(el)) * this.options.staggerMs;
    }
    refresh() { this.destroy(); this._init(); }
    destroy() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      this.elements.forEach((el) => {
        el.classList.remove(this.options.activeClass);
        el.style.transitionDelay = '';
      });
    }
  }

  window.ScrollReveal = {
    observe(containerOrSectionId, options = {}) {
      const container = typeof containerOrSectionId === 'string'
        ? document.getElementById(`shopify-section-${containerOrSectionId}`) || document.querySelector(containerOrSectionId)
        : containerOrSectionId;
      if (!container) return null;
      if (container._scrollRevealInstance) container._scrollRevealInstance.destroy();
      const instance = new ScrollRevealCore({ ...options, container });
      container._scrollRevealInstance = instance;
      return instance;
    },
  };

  // Let sections that ran before this file finished loading know it's ready.
  document.dispatchEvent(new CustomEvent('scrollreveal:ready'));
})();